import React from 'react'

type Props = {
  title: string | React.ReactElement
  faqs: {
    question: string
    answer: string | React.ReactElement
  }[]
  className?: string
}

export default function Faq({ title, faqs, className }: Props) {
  return (
    <div className={className} itemType="https://schema.org/FAQPage" itemScope>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto divide-y-2 divide-gray-200">
          <h2 className="text-center text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
            {title}
          </h2>
          <dl className="mt-12 space-y-12 divide-y divide-gray-200 prose prose-xl max-w-max">
            {faqs.map((faq) => (
              <div
                key={faq.question}
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                itemScope
              >
                <dt
                  className="text-lg leading-6 font-medium text-gray-900"
                  itemProp="name"
                >
                  {faq.question}
                </dt>
                <dd
                  className="mt-2 text-base text-gray-500"
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                  itemScope
                >
                  <div itemProp="text">{faq.answer}</div>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
